import { render, staticRenderFns } from "./header-box.vue?vue&type=template&id=7687cb66&scoped=true&"
import script from "./header-box.vue?vue&type=script&lang=js&"
export * from "./header-box.vue?vue&type=script&lang=js&"
import style0 from "./header-box.vue?vue&type=style&index=0&id=7687cb66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7687cb66",
  null
  
)

export default component.exports